"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _mediaQueries = _interopRequireDefault(require("../../utils/media-queries"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 20px;\n    line-height: 24px;\n    letter-spacing: -.2px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var H4 = _styledComponents["default"].h4.withConfig({
  displayName: "H4",
  componentId: "sc-1lkhc2f-0"
})(["font-size:24px;font-weight:600;line-height:28px;letter-spacing:-.4px;margin:0;", ""], _mediaQueries["default"].handheld(_templateObject()));

var _default = H4;
exports["default"] = _default;